import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const BackPage = () => {
    const { t } = useTranslation();

    return (
        <div className="back-page__container">
            <img alt="Last page top shape" className="shape-top" src="/img/pdf/back-top-shape.svg" />
            <div className="back-page__content">
                <img alt="Jobteaser logo" src="/img/logos/text_black.png" />
                <h1 className="back-page__title">{t('pdf.backPage.mainText')}</h1>
                <p className="back-page__subtitle">{t('pdf.backPage.subText')}</p>
            </div>
            <img alt="Last page bottom shape" className="shape-bottom" src="/img/pdf/back-bottom-shape.svg" />
        </div>
    );
};

export default BackPage;
